module.exports = __webpack_public_path__ + "static/media/bill_logictics_v2.146a58a3.png";